import styled from "@xstyled/styled-components"

const StyledPageWrap = styled.box`
  margin: 0 auto;
  overflow: hidden;
`

export default StyledPageWrap
